// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Translations } from "../schema";

export function serialize_Translations_internal(value: Translations): unknown {
  return ((value: { keys: { additionalProperties: Record<string, string> } }): unknown => {
    return {
      keys: ((value: { additionalProperties: Record<string, string> }): unknown => {
        const unordered_obj: Record<string, unknown> = {
          ...Object.fromEntries(
            Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
              return [
                propertyKey,
                ((value: string): unknown => {
                  return value;
                })(propertyValue),
              ];
            }),
          ),
        };
        return Object.keys(unordered_obj)
          .sort()
          .reduce(
            (obj, key) => {
              obj[key] = unordered_obj[key];
              return obj;
            },
            {} as Record<string, unknown>,
          );
      })(value["keys"]),
    };
  })(value);
}
export function serialize_Translations(obj: Translations): string {
  return renderJsonWithNumbersAsBigint(serialize_Translations_internal(obj));
}
export function deserialize_Translations_internal(value: unknown): ParserResult<Translations> {
  return ((
    value: unknown,
  ): ParserResult<{
    keys: { additionalProperties: Record<string, string> };
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/Translations]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/Translations]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "keys")) {
      return { success: false, reason: `[#/components/schemas/Translations/keys]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'keys'.` };
    }
    const parsed_keys = ((): ParserResult<{ additionalProperties: Record<string, string> }> => {
      return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string> }> => {
        if (typeof value !== "object") {
          return { success: false, reason: `[#/components/schemas/Translations/keys]: '${value}' expected to be of type 'object'.` };
        }
        if (value === null) {
          return { success: false, reason: `[#/components/schemas/Translations/keys]: '${value}' expected to not be null.` };
        }
        const parsed_additionalProperties = ((): ParserResult<Record<string, string>> => {
          const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string>] => {
            return [
              key,
              ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/Translations/keys/additionalProperty]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value),
            ];
          });
          if (parsed.find(([_, value]) => !value.success) !== undefined) {
            return {
              success: false,
              reason: `[#/components/schemas/Translations/keys]: Reason(s): '${parsed
                .map(([_, value]) => value)
                .filter((p) => !p.success)
                .map((p) => p.reason)
                .join(", ")}'.`,
            };
          }
          return {
            success: true,
            value: Object.fromEntries(
              parsed.map(([key, value]) => {
                assert(value.success);
                return [key, value.value];
              }),
            ),
          };
        })();
        if (!parsed_additionalProperties.success) {
          return { success: false, reason: parsed_additionalProperties.reason };
        }
        return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
      })(value["keys"]);
    })();
    if (!parsed_keys.success) {
      return { success: false, reason: parsed_keys.reason };
    }
    return { success: true, value: { keys: parsed_keys.value } };
  })(value);
}
export function deserialize_Translations(str: string): ParserResult<Translations> {
  return deserialize_Translations_internal(parseJsonWithNumbersAsBigint(str));
}
